import { times } from 'lodash';
import { Box } from '@frameio/vapor';
import { InviteAccessMemberRowSkeleton } from '../InviteAccessMemberRow/InviteAccessMemberRow';

export const InviteAccessMemberRowSkeletonsForList = ({
  count,
}: {
  count: number;
}) => (
  <>
    {times(count, (index) => (
      <Box
        key={index}
        aria-hidden="true"
        style={{
          paddingLeft: `20px`,
          paddingRight: `13px`,
        }}
      >
        <InviteAccessMemberRowSkeleton />
      </Box>
    ))}
  </>
);
